module.exports = __webpack_public_path__ + "static/media/send_gift.11785dc9.svg";